import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { Transaction, EvaluateServiceTransaction, ImportMappingsPayload, ParsedImportData, GetAllTransactionTypesResponse } from '../models';
import { ObjectResponse, ListResponse, ResultResponse } from '../interfaces';

@Injectable()
export class TransactionsService extends BaseService<Transaction> {
  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getAllTransactionTypes(): Observable<ResultResponse<GetAllTransactionTypesResponse>> {
    return this.http.get<ResultResponse<GetAllTransactionTypesResponse>>(`${this.baseUrl}transaction-types`);
  }

  // returns a list of transaction types filtering out those which are not used in transactions in current container
  public getTransactionTypesForContainer(filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}types/`);

    return this.http.get(apiUrl);
  }

  public getSourceEntities(filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}source-entities/`);

    return this.http.get(apiUrl);
  }

  public getDestinationEntities(filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}destination-entities/`);

    return this.http.get(apiUrl);
  }

  public getServiceTransactionEvaluation(transactionId: number): Observable<any> {
    return this.http.get(`${this.getResourceUrl()}${transactionId}/service-evaluation`);
  }

  public saveServiceTransactionEvaluation(transactionId: number, data: EvaluateServiceTransaction): Observable<any> {
    return this.http.put(`${this.getResourceUrl()}${transactionId}/service-evaluation`, data);
  }

  uploadImportTransactionsFile(file: File): Observable<ObjectResponse<ParsedImportData>> {
    const headers = new HttpHeaders();
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<ObjectResponse<ParsedImportData>>(`${this.getResourceUrl()}upload`, formData, { headers });
  }

  submitMappings(data: ImportMappingsPayload): Observable<ListResponse<Transaction>> {
    return this.http.post<ListResponse<Transaction>>(`${this.getResourceUrl()}mappings`, data);
  }

  getResourceUrl(): string {
    return `${this.baseUrl}transactions/`;
  }
}
